/**
 * W3C Trace Context 格式的 traceparent 生成工具
 * 格式: version-traceid-spanid-flags (如 00-{32位hex}-{16位hex}-{2位flags})
 *
 * @see https://www.w3.org/TR/trace-context/#traceparent-header
 */

/** span-id 字节数，对应 16 位十六进制 */
export const SPAN_ID_BYTES = 8;
/** trace-id 字节数，对应 32 位十六进制 */
export const TRACE_ID_BYTES = 16;

const HEX_CHARS = '0123456789abcdef';
const SHARED_CHAR_ARRAY = new Array<string>(32);

/**
 * 生成指定字节长度的十六进制随机 ID（每字节 2 个 hex 字符）
 * 复用内部数组以减少小字符串分配
 *
 * @param bytes 字节数
 */
export const generateId = (bytes: number): string => {
  const len = bytes * 2;
  for (let i = 0; i < len; i++) {
    SHARED_CHAR_ARRAY[i] = HEX_CHARS[Math.floor(Math.random() * 16)];
  }
  return SHARED_CHAR_ARRAY.slice(0, len).join('');
};

/**
 * 生成 W3C traceparent 请求头值
 *
 * @param sampled 是否采样，默认 true（01=采样，00=未采样）
 */
export const generateTraceParent = (sampled = true): string =>
  `00-${generateId(TRACE_ID_BYTES)}-${generateId(SPAN_ID_BYTES)}-${sampled ? '01' : '00'}`;

/**
 * 生成完整追踪信息（含拆开的 traceId/spanId 和拼好的 traceparent）
 *
 * @param sampled 是否采样
 */
export const generateTraceInfo = (sampled = true) => {
  const traceId = generateId(TRACE_ID_BYTES);
  const spanId = generateId(SPAN_ID_BYTES);
  const flags = sampled ? '01' : '00';
  return { traceId, spanId, flags, traceparent: `00-${traceId}-${spanId}-${flags}` };
};
